export const monochromeColors = (count) => {
    const colors = [];
    const base = '#6842ff';
    let i;

    const zn = count / 0.4;
    for (i = 0; i < count; i += 1) {
        colors.push(Highcharts.color(base).brighten(i / zn).get());
    }
    return colors;
};
